export const DEFAULT_ALGO_CONFIG = {
  id: "",
  configName: "Example",
  ChaseOrder: {
    AlgoOrderID: 1,
    UseAlgoOrder: false,
    Hotkey: "Ctrl+1",
    Side: "SELL",
    Type: "LIMIT",
    TimeInForce: "GTX",
    Size: 100.0,
    SizeRandomRate: 0.0,
    PriceBasis: "QuotedPrice",
    ConstantPriceBasis: 100.0,
    PriceBasisMultiplier: 1.0,
    PriceOffset: "StDev",
    PriceOffsetMultiplier: 2.0,
    PriceRandomRate: 0.0,
    CancelDistance: "Tick",
    CancelDistanceMultiplier: 1.0,
    RefreshDistance: "StDev",
    CloseRefreshThresholdMultiplier: 0.5,
    FarRefreshThresholdMultiplier: 1.5,
    MinDistance: "StDev",
    MinDistanceMultiplier: 0.1,
    MaxDistance: "StDev",
    MaxDistanceMultiplier: 3.0,
    MinZScore: -10.0,
    MaxZScore: 10.0,
    WaitTime: 0.0,
    WaitTimeRandomRate: 0.0,
    RefreshTime: 1000.0,
    RefreshTimeRandomRate: 0.0,
    RefreshNumber: 30,
    RefreshNumberRandomRate: 0.0,
    FreezingTime: 0.0,
    FreezingTimeRandomRate: 0.0,
    PauseTime: 0.0,
    PauseTimeRandomRate: 0.0,
    AutoContinuation: true,
  },
  ScaleOrder: {
    AlgoOrderID: 2,
    UseAlgoOrder: false,
    Hotkey: "Ctrl+2",
    Side: "BUY",
    TimeInForce: "GTX",
    TotalSize: 100.0,
    SizeRandomRate: 0.0,
    SizeScaleType: "Hyperbolic",
    SizeScaleDirection: "Up",
    OrdersNumber: 5,
    RangeStartBasis: "QuotedPrice",
    ConstantRangeStartBasis: 0.0,
    RangeStartBasisMultiplier: 1.0,
    RangeStartOffset: "StDev",
    RangeStartOffsetMultiplier: -2.0,
    RangeEndBasis: "QuotedPrice",
    ConstantRangeEndBasis: 0.0,
    RangeEndBasisMultiplier: 1.0,
    RangeEndOffset: "StDev",
    RangeEndOffsetMultiplier: -3.0,
    PriceRandomRate: 0.0,
    CancelDistance: "Tick",
    CancelDistanceMultiplier: 1.0,
    RefreshDistance: "StDev",
    CloseRefreshThresholdMultiplier: 0.5,
    FarRefreshThresholdMultiplier: 2.5,
    MinDistance: "StDev",
    MinDistanceMultiplier: 0.1,
    MaxDistance: "StDev",
    MaxDistanceMultiplier: 5.0,
    MinZScore: -10.0,
    MaxZScore: 10.0,
    WaitTime: 0.0,
    WaitTimeRandomRate: 0.0,
    RefreshTime: 1000.0,
    RefreshTimeRandomRate: 0.0,
    RefreshNumber: 30,
    RefreshNumberRandomRate: 0.0,
    FreezingTime: 0.0,
    FreezingTimeRandomRate: 0.0,
    PauseTime: 0.0,
    PauseTimeRandomRate: 0.0,
    AutoContinuation: true,
  },
  Grid: {
    AlgoOrderID: 3,
    UseAlgoOrder: false,
    Hotkey: "Ctrl+3",
    Side: "Neutral",
    TimeInForce: "GTX",
    BidTotalSize: 10000.0,
    BidSizeRandomRate: 0.0,
    BidSizeScaleType: "Hyperbolic",
    BidSizeScaleDirection: "Up",
    AskTotalSize: 10000.0,
    AskSizeRandomRate: 0.0,
    AskSizeScaleType: "Hyperbolic",
    AskSizeScaleDirection: "Up",
    OrdersNumber: 10,
    LowerRangeBasis: "QuotedPrice",
    ConstantLowerRangeBasis: 0.0,
    LowerRangeBasisMultiplier: 1.0,
    LowerRangeOffset: "StDev",
    LowerRangeOffsetMultiplier: -1.0,
    UpperRangeBasis: "QuotedPrice",
    ConstantUpperRangeBasis: 0.0,
    UpperRangeBasisMultiplier: 1.0,
    UpperRangeOffset: "StDev",
    UpperRangeOffsetMultiplier: 1.0,
    StartOrderDistance: "Tick",
    StartOrderDistanceMultiplier: 1.0,
    StopOrderDistance: "Tick",
    StopOrderDistanceMultiplier: 1.0,
    CancelDistance: "StDev",
    LowerRangeCancelDistanceMultiplier: 0.1,
    UpperRangeCancelDistanceMultiplier: 0.1,
    MinZScore: -10.0,
    MaxZScore: 10.0,
    WaitTime: 0.0,
    WaitTimeRandomRate: 0.0,
    RefreshTime: 1000.0,
    RefreshTimeRandomRate: 0.0,
    RefreshNumber: 3600,
    RefreshNumberRandomRate: 0.0,
    PauseTime: 0.0,
    PauseTimeRandomRate: 0.0,
    AutoContinuation: true,
  },
  ImplementationShortfall: {
    AlgoOrderID: 4,
    UseAlgoOrder: false,
    Hotkey: "Ctrl+4",
    MinSize: 10.0,
    MaxSize: 100.0,
    SizeRandomRate: 0.5,
    TargetInventory: 1000.0,
    InventoryTolerance: 50.0,
    MinPrice: 0.0,
    MaxPrice: 1000000000.0,
    OrderThrowDepth: 0.1,
    SkewThreshold: 0.5,
    MinZScore: -10,
    MaxZScore: 0.0,
    RefreshTime: 1000.0,
    RefreshTimeRandomRate: 0.5,
    AutoContinuation: true,
  },
};

export const PRICE_OFFSET_OPTIONS = [
  { label: "Tick", value: "Tick" },
  { label: "Percent", value: "Percent" },
  { label: "StDev", value: "StDev" },
  { label: "ATR", value: "ATR" },
  { label: "RV", value: "RV" },
];

export const REFRESH_DISTANCE_OPTIONS = [
  { label: "Tick", value: "Tick" },
  { label: "Percent", value: "Percent" },
  { label: "StDev", value: "StDev" },
  { label: "ATR", value: "ATR" },
  { label: "RV", value: "RV" },
];

export const PRICE_BASIS_OPTIONS = [
  { label: "Constant", value: "Constant" },
  { label: "QuotedPrice", value: "QuotedPrice" },
  { label: "SMA", value: "SMA" },
  { label: "LinReg", value: "LinReg" },
  { label: "VWMA", value: "VWMA" },
  { label: "Highest", value: "Highest" },
  { label: "Lowest", value: "Lowest" },
];

export const SCALE_TYPE_OPTIONS = [
  { label: "Linear", value: "Linear" },
  { label: "Hyperbolic", value: "Hyperbolic" },
  { label: "Geometric", value: "Geometric" },
  { label: "Flat", value: "Flat" },
];

export const SCALE_DIRECTION_OPTIONS = [
  { label: "Up", value: "Up" },
  { label: "Down", value: "Down" },
];

export const GRID_SIDE_OPTIONS = [
  { label: "Neutral", value: "Neutral" },
  { label: "Buy", value: "Buy" },
  { label: "Sell", value: "Sell" },
];

export const ORDER_MOVE_DIRECTION_OPTIONS = [
  { label: "FixRange", value: "FixRange" },
  { label: "Frontrun", value: "Frontrun" },
  { label: "Backrun", value: "Backrun" },
];

export const MIN_DISTANCE_OPTIONS = [
  { label: "Tick", value: "Tick" },
  { label: "Percent", value: "Percent" },
  { label: "StDev", value: "StDev" },
  { label: "ATR", value: "ATR" },
  { label: "RV", value: "RV" },
];

export const MAX_DISTANCE_OPTIONS = [
  { label: "Tick", value: "Tick" },
  { label: "Percent", value: "Percent" },
  { label: "StDev", value: "StDev" },
  { label: "ATR", value: "ATR" },
  { label: "RV", value: "RV" },
];

export type AlgoConfig = {
  id: string; // unique identifier
  configName: string;
  ChaseOrder: ChaseOrderConfig;
  ScaleOrder: ScaleOrderConfig;
  Grid: GridConfig;
  ImplementationShortfall: ImplementationShortfallConfig;
};

export type ChaseOrderConfig = {
  AlgoOrderID: number;
  UseAlgoOrder: boolean;
  Hotkey: string;
  Side: string;
  Type: string;
  TimeInForce: string;
  Size: number;
  SizeRandomRate: number;
  PriceBasis: string;
  ConstantPriceBasis: number;
  PriceBasisMultiplier: number;
  PriceOffset: string;
  PriceOffsetMultiplier: number;
  PriceRandomRate: number;
  CancelDistance: string;
  CancelDistanceMultiplier: number;
  RefreshDistance: string;
  CloseRefreshThresholdMultiplier: number;
  FarRefreshThresholdMultiplier: number;
  MinDistance: string;
  MinDistanceMultiplier: number;
  MaxDistance: string;
  MaxDistanceMultiplier: number;
  MinZScore: number;
  MaxZScore: number;
  WaitTime: number;
  WaitTimeRandomRate: number;
  RefreshTime: number;
  RefreshTimeRandomRate: number;
  RefreshNumber: number;
  RefreshNumberRandomRate: number;
  FreezingTime: number;
  FreezingTimeRandomRate: number;
  PauseTime: number;
  PauseTimeRandomRate: number;
  AutoContinuation: boolean;
};

export type ScaleOrderConfig = {
  AlgoOrderID: number;
  UseAlgoOrder: boolean;
  Hotkey: string;
  Side: string;
  TimeInForce: string;
  TotalSize: number;
  SizeRandomRate: number;
  SizeScaleType: string;
  SizeScaleDirection: string;
  OrdersNumber: number;
  RangeStartBasis: string;
  ConstantRangeStartBasis: number;
  RangeStartBasisMultiplier: number;
  RangeStartOffset: string;
  RangeStartOffsetMultiplier: number;
  RangeEndBasis: string;
  ConstantRangeEndBasis: number;
  RangeEndBasisMultiplier: number;
  RangeEndOffset: string;
  RangeEndOffsetMultiplier: number;
  PriceRandomRate: number;
  CancelDistance: string;
  CancelDistanceMultiplier: number;
  RefreshDistance: string;
  CloseRefreshThresholdMultiplier: number;
  FarRefreshThresholdMultiplier: number;
  MinDistance: string;
  MinDistanceMultiplier: number;
  MaxDistance: string;
  MaxDistanceMultiplier: number;
  MinZScore: number;
  MaxZScore: number;
  WaitTime: number;
  WaitTimeRandomRate: number;
  RefreshTime: number;
  RefreshTimeRandomRate: number;
  RefreshNumber: number;
  RefreshNumberRandomRate: number;
  FreezingTime: number;
  FreezingTimeRandomRate: number;
  PauseTime: number;
  PauseTimeRandomRate: number;
  AutoContinuation: boolean;
};

export type GridConfig = {
  AlgoOrderID: number;
  UseAlgoOrder: boolean;
  Hotkey: string;
  Side: string;
  TimeInForce: string;
  BidTotalSize: number;
  BidSizeRandomRate: number;
  BidSizeScaleType: string;
  BidSizeScaleDirection: string;
  AskTotalSize: number;
  AskSizeRandomRate: number;
  AskSizeScaleType: string;
  AskSizeScaleDirection: string;
  OrdersNumber: number;
  LowerRangeBasis: string;
  ConstantLowerRangeBasis: number;
  LowerRangeBasisMultiplier: number;
  LowerRangeOffset: string;
  LowerRangeOffsetMultiplier: number;
  UpperRangeBasis: string;
  ConstantUpperRangeBasis: number;
  UpperRangeBasisMultiplier: number;
  UpperRangeOffset: string;
  UpperRangeOffsetMultiplier: number;
  StartOrderDistance: string;
  StartOrderDistanceMultiplier: number;
  StopOrderDistance: string;
  StopOrderDistanceMultiplier: number;
  CancelDistance: string;
  LowerRangeCancelDistanceMultiplier: number;
  UpperRangeCancelDistanceMultiplier: number;
  MinZScore: number;
  MaxZScore: number;
  WaitTime: number;
  WaitTimeRandomRate: number;
  RefreshTime: number;
  RefreshTimeRandomRate: number;
  RefreshNumber: number;
  RefreshNumberRandomRate: number;
  PauseTime: number;
  PauseTimeRandomRate: number;
  AutoContinuation: boolean;
};

export type ImplementationShortfallConfig = {
  AlgoOrderID: number;
  UseAlgoOrder: boolean;
  Hotkey: string;
  MinSize: number;
  MaxSize: number;
  SizeRandomRate: number;
  TargetInventory: number;
  InventoryTolerance: number;
  MinPrice: number;
  MaxPrice: number;
  OrderThrowDepth: number;
  SkewThreshold: number;
  MinZScore: number;
  MaxZScore: number;
  RefreshTime: number;
  RefreshTimeRandomRate: number;
  AutoContinuation: boolean;
};
